import { MmSelectionState } from '../../core/selection';
import { MmSkuKey } from '../../types/domain';
import { MmTaskType } from '../../types/enums';
import { MmTaskCreateLevels, MmTaskCreateZone } from './buildTaskCreatePayload';

export interface MmTaskCreateDraft {
  tradingNetworkId: number;
  type: MmTaskType | null;
  zone: MmTaskCreateZone;
  levels: MmTaskCreateLevels;
  comment: string;
  isPriceCheckerEnabled: boolean;
  selection: MmSelectionState<MmSkuKey>;
  productsTotal: number;
}

let draft: MmTaskCreateDraft | null = null;

export function saveTaskCreateDraft(next: MmTaskCreateDraft): void {
  draft = next;
}

export function takeTaskCreateDraft(tradingNetworkId: number | null): MmTaskCreateDraft | null {
  if (draft === null || tradingNetworkId === null) {
    return null;
  }

  if (draft.tradingNetworkId !== tradingNetworkId) {
    // Черновик чужой сети выбрасываем сразу, иначе он всплывёт с устаревшими данными
    draft = null;

    return null;
  }

  const restored = draft;

  draft = null;

  return restored;
}

export function clearTaskCreateDraft(): void {
  draft = null;
}

export function hasTaskCreateDraft(tradingNetworkId: number | null): boolean {
  return draft !== null && tradingNetworkId !== null && draft.tradingNetworkId === tradingNetworkId;
}

export function peekTaskCreateDraftType(tradingNetworkId: number | null): MmTaskType | null {
  if (draft === null || tradingNetworkId === null || draft.tradingNetworkId !== tradingNetworkId) {
    return null;
  }

  return draft.type;
}

export function isDraftWorthKeeping(candidate: MmTaskCreateDraft): boolean {
  if (candidate.type !== null) {
    return true;
  }

  const zone = candidate.zone;
  const levels = candidate.levels;

  return (
    zone.formats.length > 0 ||
    zone.regions.length > 0 ||
    zone.clusters.length > 0 ||
    levels.groups.length > 0 ||
    levels.categories.length > 0 ||
    levels.subCategories.length > 0 ||
    candidate.comment !== '' ||
    candidate.selection.included.length > 0 ||
    candidate.selection.excluded.length > 0 ||
    candidate.selection.isCommonCheckboxSelected
  );
}
